import NiceModal from '@ebay/nice-modal-react';
import { Box } from '@mantine/core';

import { useGetGoods } from '../api/getGoodsItem';

import { AddModal } from './AddModal';
import { GoodsTable } from './Table';

import { AddButton, ListLoader } from '@/components';
import { Departments } from '@/types';

type GoodsListProps = {
  department: Departments;
};

export const GoodsList = ({ department }: GoodsListProps) => {
  const { data, isLoading } = useGetGoods({ department });

  if (isLoading) {
    return <ListLoader />;
  }

  if (!data?.goods.length) {
    return <ListAddButton department={department} />;
  }

  return (
    <Box style={{ display: 'grid', height: 'calc(100vh - 105px)', gridTemplateRows: 'auto 70px' }}>
      <Box style={{ overflow: 'auto' }}>
        <GoodsTable department={department} goods={data.goods} />
      </Box>
      <ListAddButton department={department} />
    </Box>
  );
};

function ListAddButton({ department }: { department: Departments }) {
  return (
    <AddButton
      size={60}
      onClick={() =>
        NiceModal.show(AddModal, {
          initialValues: {
            department,
            name: '',
            key: '',
          },
        })
      }
    />
  );
}
